module.exports = __webpack_public_path__ + "static/img/01.baf05f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commodity/05/01.jpg
// module id = 1KfS
// module chunks = 0